declare global {
  interface Window {
    onGoogleScriptLoaded?: () => void;
  }
}

let scriptLoadedPromise: Promise<void> | null = null;

export const loadGoogleScript = (): Promise<void> => {
  // Check if the script is already loaded
  // This is only added as a precaution as the script should only be loaded once
  // and could be loaded by a different component/code
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Not needed in ssr environment"));
  }

  // If the script is currently being loaded, return the existing promise
  if (scriptLoadedPromise != null) {
    return scriptLoadedPromise;
  }

  // Create a promise to load the script
  scriptLoadedPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://apis.google.com/js/api.js?onload=onGoogleScriptLoaded";
    script.async = true;
    script.defer = true;
    script.onerror = () => reject(new Error(`Failed to load Google script`));

    // Define the global callback that resolves the promise
    window.onGoogleScriptLoaded = () => {
      resolve();
    };

    document.head.appendChild(script);
  });

  return scriptLoadedPromise;
};
